import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Subscriber, Observable, BehaviorSubject } from 'rxjs';
import { LoaderProvider } from '../loader/loader';
import { LoadingController, NavController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { LoginModel, PrivateProfile, UserProvider } from '../user/user';
import { AppDetectorProvider } from '../detector/detector';
import { GlobalUtil } from '../../tracker/global-utils';
import { StorageProvider } from '../storage-service/storage-service';

/*
  Generated class for the SessionProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SessionProvider {
  // private _storage:Storage=null;
  public profile: PrivateProfile = null;
  public isLoged: boolean = false;
  constructor(
    public http: HttpClient,
    private storage: Storage,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    private detector: AppDetectorProvider,
    private storageService:StorageProvider
  ) {
    console.log('[session.ts] constructor');
  }

  requestPageSub: Subject<any> = new Subject();
  requestPageProfileEdit: Subject<any> = new Subject();
  requestLoggedIn: Subject<any> = new Subject();
  requestLogout: Subject<any> = new Subject();

  public getToken(first: boolean = false, profileRequired: boolean = true): Promise<string> {
    console.log('getToken()');
    return new Promise((resolve, reject) => {
      this.loadingCtrl.dismiss();

      let key = (this.detector.isHellaApp()) ? "tokenID" + GlobalUtil.getInstance().currentEventID : "token";

      // let key = (this.detector.isHellaApp()) ? "token" : "token";
      this.storageService.create().then(()=>{
        this.storageService._storage.get(key).then(async(token) => {
          if (!token || token=='null') {
            const localStorageToken = localStorage.getItem('token');
            if (localStorageToken && localStorageToken!=='null') {
              console.log('Token found in localStorage, restoring to _storage');
              await this.storageService._storage.set(key, localStorageToken);
              token = localStorageToken;
            }
          }

          if ((token && token!=='null') || first) {
            resolve(token);
          } else {
            // this.loadingCtrl.dismissAll();
            // this.requestPageSub.next(true);
            const toast = await this.toastCtrl
              .create({
                message: this.translate.instant('LOGIN_HAVE_TO_LOGIN'),
                buttons: [{ text: 'OK', role: 'cancel' }],
                duration: 3000
              })
            toast.present();
            resolve(null)
          }
        });
      })
    });
  }

  public getTokenAndNavigate(first: boolean = false, profileRequired: boolean = true): Promise<string> {
    return new Promise((resolve, reject) => {
      let key = (this.detector.isHellaApp()) ? "tokenID" + GlobalUtil.getInstance().currentEventID : "token";

      this.storageService.create().then(()=>{
        this.storageService._storage.get(key).then(async(token) => {
          if (!token || token=='null') {
            const localStorageToken = localStorage.getItem('token');
            if (localStorageToken && localStorageToken!=='null') {
              console.log('Token found in localStorage, restoring to _storage');
              await this.storageService._storage.set(key, localStorageToken);
              token = localStorageToken;
            }
          }

          if ((token && token!=='null') || first) {
            if (profileRequired) {
              if (!this.checkUserProfile() && !first && !this.detector.isHellaApp()) {
                // this.loadingCtrl.dismissAll();
                this.requestPageProfileEdit.next(true);
                const toast = await this.toastCtrl
                  .create({
                    message: this.translate.instant('PRIVATEPROFILE_FILL_THE_FORM_FIRST'),
                    buttons: [{ text: 'OK', role: 'cancel' }],
                    duration: 3000
                  })
                  toast.present();
              } else {
                resolve(token);
              }
            } else {
              resolve(token);
            }
          } else {
            // this.loadingCtrl.dismissAll();
            this.requestPageSub.next({ resolve: resolve });
            const toast = await this.toastCtrl
              .create({
                message: this.translate.instant('LOGIN_HAVE_TO_LOGIN'),
                buttons: [{ text: 'OK', role: 'cancel' }],
                duration: 3000
              })
              toast.present();
          }
        });
      })
    });
  }

  public checkUserProfile(): boolean {
    if (
      this.profile !== null &&
      (!this.profile.forName || this.profile.forName.length === 0 || !this.profile.surName || this.profile.surName.length === 0)
    ) {
      return false;
    }
    return true;
  }

  public onTriggerPageProfileEdit() {
    this.requestPageProfileEdit.next(true);
  }

  public onRequestPageLogin(): Subject<any> {
    return this.requestPageSub;
  }

  public onRequestPageProfileEdit(): Subject<any> {
    return this.requestPageProfileEdit;
  }

  public onRequestLoggedIn(): Subject<any> {
    return this.requestLoggedIn;
  }

  public onRequestLogout(): Subject<any> {
    return this.requestLogout;
  }

  saveLogin(model: LoginModel, sufix: string = ""): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        this.storageService.create().then(()=>{
          this.storageService._storage
            .set('loginModel' + sufix, model)
            .then(() => { }, err => { })
            .catch(() => { });
          resolve(null);
        });
      } catch (e) {
        console.log(e);
      }
    });
  }
  deleteLogin(){
    this.storageService.create().then(()=>{
      this.storageService._storage.remove('loginModel')
    });
  }

  isOrganizer(){
    return this.profile && (this.profile.status.toLocaleUpperCase().includes("VER") || this.profile.status.toLocaleUpperCase().includes("ORG"))? true: false;
  }

  // 
  private postLoginAction: (() => void) | null = null;

  setPostLoginAction(action: () => void) {
    console.log('action', action)
    this.postLoginAction = action;
  }

  runPostLoginAction() {
    if (this.postLoginAction) {
      this.postLoginAction();
      this.postLoginAction = null;
    }
  }

  sendLoggedIn() {
    this.isLoged = true;
    this.requestLoggedIn.next(true);
    this.runPostLoginAction();
  }
  // sendLoggedIn() {
  //   this.requestLoggedIn.next(true);
  // }

  sendLogout() {
    this.requestLogout.next(true);
  }

getLogin(sufix: string = ""): Promise<LoginModel> {
    return new Promise((resolve, reject) => {
      this.storageService.create().then(()=>{
        this.storageService._storage.get('loginModel' + sufix).then(model => {
          resolve((model || { email: '', password: '' }) as LoginModel);
        });
      });
    });
  }

  getLoginStatus(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      resolve(this.isLoged);
    })
  }
}
